// extracted by mini-css-extract-plugin
module.exports = {"Nav":"navigation-links4_Nav__2b0SH","navlink":"navigation-links4_navlink__1YFW5","navlink1":"navigation-links4_navlink1__tCIIp","navlink2":"navigation-links4_navlink2__3WOpO"};